import React, { useState, useId } from 'react'

import classNames from "classnames"
import "./Accordion.css"

const Accordion = ({ head, content, ...props }) => {
    const [open, setOpen] = useState(false)

    // Eindeutige IDs für ARIA-Verknüpfung head <-> content
    const reactId = useId()
    const headId = `accordion-head-${reactId}`
    const contentId = `accordion-content-${reactId}`

    const toggle = () => setOpen(prev => !prev)

    const handleKeyDown = (e) => {
        // Toggle per Enter oder Space (Standard-ARIA-Pattern)
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggle()
        }
    }

    return (
        <div className='accordion' {...props}>
            <div
                id={headId}
                className={classNames("accordion-head", { open: open })}
                onClick={toggle}
                onKeyDown={handleKeyDown}
                role="button"
                tabIndex={0}
                aria-expanded={open}
                aria-controls={contentId}
            >
                {head}
                <span className='accordion-arrow' aria-hidden="true" />
            </div>
            <div
                id={contentId}
                className={classNames("accordion-content", { open: open })}
                role="region"
                aria-labelledby={headId}
                aria-hidden={!open}
            >
                {content}
            </div>
        </div>
    );
}

export default Accordion;